const CustomTooltip = ({ active, payload }) => {
  // Guard conditions
  if (!active || !Array.isArray(payload) || payload.length === 0) {
    return null;
  }

  const value = payload?.[0]?.value;

  if (value === undefined || value === null) {
    return null;
  }

  return (
    <div className="custom-tooltip">
      <p className="mb-0 fw-semibold">{value}</p>
    </div>
  );
};

export default CustomTooltip;